import React from "react";
import { useLanguage } from "../../../../contexts";
import "./RiskMatrixDrawer.scss";

// Todas las metodologías del handoff — las que no tienen `implemented` se
// muestran deshabilitadas con badge "Próximamente" (ver README del handoff:
// 7 metodologías totales, se van sumando de a una).
const ALL_METHODOLOGIES = [
  { key: "iso14001", icon: "📄", nameKey: "risk_matrix_methodology_iso14001", descKey: "risk_matrix_methodology_iso14001_desc", implemented: true },
  { key: "ifrs", icon: "📄", nameKey: "risk_matrix_methodology_ifrs", descKey: "risk_matrix_methodology_ifrs_desc", implemented: true },
  { key: "gri", icon: "📄", nameKey: "risk_matrix_methodology_gri", descKey: "risk_matrix_methodology_gri_desc", implemented: true },
  { key: "iso14091", icon: "📄", nameKey: "risk_matrix_methodology_iso14091", descKey: "risk_matrix_methodology_iso14091_desc", implemented: true },
  { key: "esrs", icon: "📊", nameKey: "risk_matrix_methodology_esrs", descKey: "risk_matrix_methodology_esrs_desc", implemented: true },
  { key: "leopold", icon: "📄", nameKey: "risk_matrix_methodology_leopold", descKey: "risk_matrix_methodology_leopold_desc", implemented: true },
  { key: "conesa", icon: "📄", nameKey: "risk_matrix_methodology_conesa", descKey: "risk_matrix_methodology_conesa_desc", implemented: true },
];

export function RiskMatrixDrawer({ open, onClose, methodologyKey, onSelectMethodology, onGoDashboard, onOpenGuide }) {
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  return (
    <>
      <div
        className={`risk-matrix-drawer-bg${open ? " open" : ""}`}
        onClick={onClose}
      />
      <div className={`risk-matrix-drawer${open ? " open" : ""}`}>
        <div className="risk-matrix-drawer__header">
          <b>{t("risk_matrix_menu_title")}</b>
          <button type="button" className="risk-matrix-drawer__close" onClick={onClose} aria-label="close">
            ✕
          </button>
        </div>
        <div className="risk-matrix-drawer__body">
          <div className="risk-matrix-drawer__item" onClick={onGoDashboard}>
            <span className="risk-matrix-drawer__icon">📊</span>
            <div>
              <b>{t("risk_matrix_menu_dashboard")}</b>
              <div className="risk-matrix-drawer__sub">{t("risk_matrix_menu_dashboard_sub")}</div>
            </div>
          </div>

          <div className="risk-matrix-drawer__section">{t("risk_matrix_menu_guide_section")}</div>
          <div className="risk-matrix-drawer__item" onClick={onOpenGuide}>
            <span className="risk-matrix-drawer__icon">📘</span>
            <div>
              <b>{t("risk_matrix_menu_guide_item")}</b>
              <div className="risk-matrix-drawer__sub">{t("risk_matrix_menu_guide_item_sub")}</div>
            </div>
          </div>

          <div className="risk-matrix-drawer__section">{t("risk_matrix_menu_methodologies_section")}</div>
          {ALL_METHODOLOGIES.map((m) => {
            const isCurrent = m.key === methodologyKey;
            return (
              <div
                key={m.key}
                className={`risk-matrix-drawer__item${isCurrent ? " cur" : ""}${!m.implemented ? " disabled" : ""}`}
                onClick={() => m.implemented && onSelectMethodology(m.key)}
              >
                <span className="risk-matrix-drawer__icon">{m.icon}</span>
                <div className="risk-matrix-drawer__item-body">
                  <div className="risk-matrix-drawer__item-title">
                    <b>{t(m.nameKey)}</b>
                    {isCurrent && <span className="risk-matrix-drawer__badge">{t("risk_matrix_menu_active_badge")}</span>}
                    {!m.implemented && <span className="risk-matrix-drawer__badge soon">{t("risk_matrix_menu_coming_soon")}</span>}
                  </div>
                  <div className="risk-matrix-drawer__sub">{t(m.descKey)}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}
